/* Pose2D shell layout (login, projects, settings, editor frame); every colour and size token comes from ui-kit/tokens.css. */
@import '../ui-kit/tokens.css';

html, body, #root { height: 100%; margin: 0; background: var(--p2-bg); color: var(--p2-fg); font-family: var(--p2-font); font-size: var(--p2-font-size); line-height: 1.4; }
button, input, select { font: inherit; color: inherit; background: var(--p2-bg-input); border: 1px solid var(--p2-border); border-radius: var(--p2-radius); padding: var(--p2-space-1) var(--p2-space-2); }
button { cursor: pointer; background: var(--p2-bg-raised); }
button:hover { border-color: var(--p2-border-strong); }
button:disabled { cursor: default; color: var(--p2-fg-disabled); }
button:focus-visible, input:focus-visible, select:focus-visible { outline: 1px solid var(--p2-focus-ring); outline-offset: 1px; }
.shell-center { display: grid; place-items: center; height: 100%; }
.shell-page { min-height: 100%; }
.shell-page > .shell-card { margin: var(--p2-space-3); max-width: 480px; }
.shell-card { background: var(--p2-bg-raised); border: 1px solid var(--p2-border); border-radius: var(--p2-radius); padding: var(--p2-space-3); }
.shell-form { display: flex; flex-direction: column; gap: var(--p2-space-3); min-width: 320px; }
.shell-form h1 { margin: 0; font-size: 1.5em; }
.shell-form label { display: flex; flex-direction: column; gap: var(--p2-space-1); color: var(--p2-fg-muted); }
.shell-header { display: flex; align-items: center; gap: var(--p2-space-3); padding: var(--p2-space-2) var(--p2-space-3); border-bottom: 1px solid var(--p2-border); }
.shell-title { flex: 1; color: var(--p2-fg-muted); }
.shell-nav { display: flex; gap: var(--p2-space-2); }
.shell-error { color: var(--p2-danger); white-space: pre-line; }
.shell-error button { color: var(--p2-fg); }
.shell-error pre { margin: 0 0 var(--p2-space-2); white-space: pre-wrap; }
.shell-header .shell-error { margin: 0; }
#root > .shell-error { margin: var(--p2-space-3); max-width: 480px; }
.shell-page > .shell-error, .editor-frame > .shell-error { padding: var(--p2-space-2) var(--p2-space-3); }
.shell-error > p { margin: 0 0 var(--p2-space-2); }
.shell-hint, .shell-splash { color: var(--p2-fg-muted); }
.shell-splash { padding: var(--p2-space-3); }
.projects-toolbar { display: flex; flex-wrap: wrap; gap: var(--p2-space-2); padding: var(--p2-space-3); }
.projects-new { display: flex; gap: var(--p2-space-2); margin-left: auto; }
.project-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: var(--p2-space-3); padding: 0 var(--p2-space-3) var(--p2-space-3); }
.project-card { display: flex; flex-direction: column; gap: var(--p2-space-1); }
.project-thumb { padding: 0; aspect-ratio: 4 / 3; overflow: hidden; }
.project-thumb img { width: 100%; height: 100%; object-fit: contain; }
.project-thumb-empty { display: block; width: 100%; height: 100%; background: repeating-linear-gradient(45deg, var(--p2-bg-raised) 0 10px, var(--p2-bg-input) 10px 20px); }
.project-name { margin: 0; font-size: 1.15em; overflow-wrap: anywhere; }
.project-meta { margin: 0; color: var(--p2-fg-muted); }
.editor-frame { display: flex; flex-direction: column; height: 100%; }
.editor-animate { outline: 3px solid var(--p2-animate); outline-offset: -3px; }
.editor-dock { flex: 1; min-height: 0; }
.panel-placeholder { display: grid; place-items: center; height: 100%; color: var(--p2-fg-muted); }
